<template>
	<v-app :style="cssVars">
		<component v-if="!!layout" :is="layout" component="">
			<router-view></router-view>
		</component>
		<div v-else>Loading...</div>
	</v-app>
</template>

<script>
import GuestLayout from './components/Layouts/GuestLayout'
import AppLayout from './components/Layouts/AppLayout'
import { uuid } from 'vue-uuid'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'App',
	components: {
		GuestLayout,
		AppLayout,
	},
	computed: {
		...mapGetters('settings', ['web', 'ci_cd', 'styles']),

		layout() {
			const layout = [...this.$route.matched]
				.filter((route) => route.meta.layout)
				.map((route) => route.meta.layout)
				.reverse()
				.shift()
			return layout ? `${layout}-layout` : 'guest-layout'
		},
		cssVars() {
			const {
				cell_detail_text: cellDetailText,
				primary_color: primaryColor,
				secondary_color: secondaryColor,
			} = this.styles || {}

			return {
				'--accent-color': primaryColor,

				'--button-login-background': primaryColor,
				'--button-login': '#ffffff',

				'--button-main-background-color': primaryColor,
				'--button-main-color': '#ffffff',
				'--button-icon-tint': primaryColor,

				'--button-secondary-background-color': secondaryColor,
				'--button-secondary-color': '#ffffff',

				'--chip-text-normal': primaryColor,
				'--chip-text-selected': '#ffffff',
				'--chip-normal-background': '#ffffff',
				'--chip-selected-background': primaryColor,

				'--badge-pin-background': primaryColor,
				'--badge-sponsored-background': primaryColor,
				'--username-category-title': primaryColor,
				'--company-position-large': '#4a4a4a',
				'--location-color': '#4a4a4a',
				'--ceil-detail-text-color': cellDetailText,
				'--link': primaryColor,
				'--text_button_tint': primaryColor,
				'--checkmark_tint': secondaryColor,
				'--vote_bar_tint': secondaryColor,
				'--calendar_point_tint': secondaryColor,
				'--action_sheet_label': '#4a4a4a',
				'--primary_color': primaryColor,
				'--secondary_color': secondaryColor,
				'--placeholder_active': '#4a4a4a',
			}
		},
	},
	watch: {
		web() {
			const { favicon_image: favicon } = this.web
			this.updateFavicon(favicon)
		},
		ci_cd() {
			const { device_name: cloneTitle } = this.ci_cd
			this.changeTitle(cloneTitle)
		},
	},
	created() {
		// test
		this.setSessionId(uuid.v4())
	},
	methods: {
		...mapActions('app', ['setSessionId']),

		changeTitle(title) {
			document.title = title
		},

		updateFavicon(newFavicon) {
			this.favicon = newFavicon

			const faviconLink = document.querySelector("link[rel='icon']")

			if (faviconLink) {
				faviconLink.href = newFavicon
			}
		},
	},
}
</script>

<style lang="scss">
.u-cursor-pointer {
	cursor: pointer;
}
.page {
	margin-bottom: 10px;

	@media (max-width: 919px) {
		padding-top: 4px;
	}
}
</style>
